import ContentMega from 'components/ContentMega';

function Mega(props) {
  const newProps = {
    ...props.banner_data,
    anchorId: props.banner_data.anchor_id,
    backgroundImage: {
      title: props.banner_data.title,
      url: props.banner_data.image_mobile?.url || props.banner_data.image?.url,
    },
    backgroundImageDesktop: {
      title: props.banner_data.title,
      url: props.banner_data.image?.url,
    },
    smallHeading: props.banner_data.lead_in,
    heading: props.banner_data.title,
    subHeading: props.banner_data.description,
    ctaText: props.banner_data.cta_link.title,
    ctaUrl: props.banner_data.cta_link.href,
    linkText: props.banner_data.link?.title,
    linkUrl: props.banner_data.link?.href,
    headingTag: props.banner_data.heading_tag,
    alignment: props.banner_data.alignment,
    isSetDangerously: true,
    parallax: props.banner_data.parallax,
    backgroundColor: props.banner_data.background_color,
    useSmallHeading: props.banner_data.use_small_heading,
    overrideBannerType: props.banner_data.override_banner_type,
  };

  return <ContentMega {...newProps} />;
}

export default Mega;
